var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51562 0.71875C2.03906 0.71875 1.58202 0.908063 1.24504 1.24504C0.908063 1.58202 0.71875 2.03906 0.71875 2.51562C0.71875 2.99219 0.908063 3.44923 1.24504 3.78621C1.58202 4.12319 2.03906 4.3125 2.51562 4.3125C2.99219 4.3125 3.44923 4.12319 3.78621 3.78621C4.12319 3.44923 4.3125 2.99219 4.3125 2.51562C4.3125 2.03906 4.12319 1.58202 3.78621 1.24504C3.44923 0.908063 2.99219 0.71875 2.51562 0.71875Z",
    stroke: "#808080",
    strokeWidth: 1.4375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51562 7.00781C2.03906 7.00781 1.58202 7.19713 1.24504 7.5341C0.908063 7.87108 0.71875 8.32813 0.71875 8.80469C0.71875 9.28125 0.908063 9.73829 1.24504 10.0753C1.58202 10.4122 2.03906 10.6016 2.51562 10.6016C2.99219 10.6016 3.44923 10.4122 3.78621 10.0753C4.12319 9.73829 4.3125 9.28125 4.3125 8.80469C4.3125 8.32813 4.12319 7.87108 3.78621 7.5341C3.44923 7.19713 2.99219 7.00781 2.51562 7.00781Z",
    stroke: "#808080",
    strokeWidth: 1.4375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51562 13.2969C2.03906 13.2969 1.58202 13.4862 1.24504 13.8232C0.908063 14.1601 0.71875 14.6172 0.71875 15.0937C0.71875 15.5703 0.908063 16.0274 1.24504 16.3643C1.58202 16.7013 2.03906 16.8906 2.51562 16.8906C2.99219 16.8906 3.44923 16.7013 3.78621 16.3643C4.12319 16.0274 4.3125 15.5703 4.3125 15.0938C4.3125 14.6172 4.12319 14.1601 3.78621 13.8232C3.44923 13.4862 2.99219 13.2969 2.51562 13.2969Z",
    stroke: "#808080",
    strokeWidth: 1.4375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDotsVertical);
export default __webpack_public_path__ + "static/media/icon-menu-dots-vertical.bd7acb5516120700bac40d9f84cbbe3e.svg";
export { ForwardRef as ReactComponent };